import { StepContainer } from '../components/StepContainer'
import { SingleSelect } from '../components/SingleSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { KidneyStatus } from '../types/onboarding'
import { SingleSelectV2, KIDNEY_STATUS_V2_ICONS } from '../components/v2'
import { usesAppLook } from '../lib/variant'

const options: { value: KidneyStatus; label: string; description?: string }[] = [
  { value: 'stage_1', label: 'Stage 1', description: 'Kidney damage with normal function' },
  { value: 'stage_2', label: 'Stage 2', description: 'Mild loss of function' },
  { value: 'stage_3a', label: 'Stage 3a', description: 'Mild to moderate loss' },
  { value: 'stage_3b', label: 'Stage 3b', description: 'Moderate to severe loss' },
  { value: 'stage_4', label: 'Stage 4', description: 'Severe loss of function' },
  { value: 'stage_5', label: 'Stage 5', description: 'Kidney failure' },
  { value: 'on_dialysis', label: 'On Dialysis', description: 'Currently receiving dialysis' },
  { value: 'kidney_stones', label: 'Kidney Stones', description: 'History of kidney stones' },
  { value: 'no_diagnosis', label: 'No Diagnosis Yet', description: 'Monitoring kidney health' },
  { value: 'not_sure', label: "I'm Not Sure", description: "We'll help you figure it out" },
]

const v2Options = options.map((o) => ({ ...o, icon: KIDNEY_STATUS_V2_ICONS[o.value] }))

export function KidneyStatusStep() {
  const { data, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="What's your kidney status?"
      subtitle="Select your current CKD stage or condition"
      showContinue={false}
    >
      {usesAppLook() ? (
        <SingleSelectV2
          options={v2Options}
          value={data.kidneyStatus}
          onChange={(value) => goNext({ kidneyStatus: value })}
        />
      ) : (
        <SingleSelect
          options={options}
          value={data.kidneyStatus}
          onChange={(value) => goNext({ kidneyStatus: value })}
        />
      )}
    </StepContainer>
  )
}
